import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./Offer.module.scss";
import Aos from "aos";
import "aos/dist/aos.css";
import { FaUsers, FaUser, FaChild, FaHeart, FaTrophy } from "react-icons/fa";

const offers = [
  { id: "grupni", title: "Grupni časovi", description: "Rad u grupi uz profesionalne trenere.", icon: <FaUsers /> },
  { id: "individualni", title: "Individualni časovi", description: "Personalizovani trening prilagođen vašem tempu.", icon: <FaUser /> },
  { id: "deca", title: "Časovi za decu", description: "Plesna edukacija kroz igru i zabavu.", icon: <FaChild /> },
  { id: "mladenacki", title: "Prvi mladenčki ples", description: "Koreografija za vaš poseban dan.", icon: <FaHeart /> },
  { id: "takmicarski", title: "Takmičarski ples", description: "Priprema za profesionalne plesne turnire.", icon: <FaTrophy /> },
];

const Offer = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <section className={styles.offer} id="ponuda" role="region" aria-label="Ponuda"> {/* Dodajemo role i aria-label */}
      <h2 data-aos={"fade-up"}>Šta je u ponudi?</h2>
      <div className={styles.list}>
        {offers.map((item, index) => (
          <Link to={`/offer/${item.id}`} key={index} className={styles.card} data-aos={"fade-up"}>
            <div className={styles.icon}>{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default Offer;